import styled from '@emotion/styled/macro';
import { sizes } from '../../../UserAvatar';

const TITLE_HEIGHT = '20px';
const FOOTER_HEIGHT = '20px';
const ICON_HEIGHT = TITLE_HEIGHT;

export const WorklogGroupItem = styled.div`
  @keyframes grayWhite {
    0% {
      background-color: transparent;
    }
    50% {
      background-color: #eaecef;
    }
    51% {
      background-color: #eaecef;
    }
    100% {
      background-color: transparent;
    }
  }

  display: flex;
  flex-direction: row;
  border-radius: 4px;
  animation: ${({ isSelected }) =>
    isSelected ? 'grayWhite 6s ease 1;' : 'none'};

  padding-bottom: ${({ isExpanded }) => (isExpanded ? '7px;' : '0')};
  padding-left: 4px;

  background-color: transparent;
  // &:hover {
  //   background-color: ${({ theme }) => theme.bgColors.hovered};
  // }

  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) =>
      theme.dark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};

    /* Overlay color */
    pointer-events: none; /* Allows hover events to pass through */
    opacity: 0; /* Initially transparent */
    transition: opacity 0.3s; /* Transition effect */
  }

  &:hover::after {
    opacity: 1; /* Make the overlay visible on hover */
  }
`;

export const Title = styled.div`
  display: flex;
  height: ${TITLE_HEIGHT};
  line-height: ${TITLE_HEIGHT};
  width: 100%;
  > div:not(:first-of-type) {
    margin-left: 5px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 5px;
  overflow: hidden;
  flex: 1;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 6px;
`;

export const Footer = styled.div`
  height: ${FOOTER_HEIGHT};
  line-height: ${FOOTER_HEIGHT};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #5e6c84;
  font-size: 12px;
  margin-top: 5px;
`;

export const FooterInfo = styled.div`
  :first-of-type {
    flex: 1;
    display: flex;

    > div {
      :not(:first-of-type):before {
        margin: 0 4px;
        content: '|';
      }
    }
  }
`;

export const UserName = styled.div`
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserAction = styled.div`
  display: flex;
  white-space: nowrap;
  margin-left: 5px;
  gap: 5px;
`;

export const ActionText = styled.div``;

export const TimerText = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
`;

export const ManagePanel = styled.div`
  display: flex;
  margin-left: auto !important;
  > button {
    > svg {
      height: ${ICON_HEIGHT};
      width: ${ICON_HEIGHT};
    }
  }
`;

export const CardInfo = styled.div`
  display: flex;
  flex: 1;
  min-width: 0; // it's workaround https://css-tricks.com/flexbox-truncated-text/
`;

export const CardName = styled.span`
  margin-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // color: #172b4d;
  cursor: pointer;
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  align-self: center;
  background-color: ${({ timerStatus }) =>
    timerStatus === 'pause' ? 'orange' : 'green'};
`;

export const Divider = styled.hr`
  margin: 6px 0 0 0;
  background-color: ${({ theme }) =>
    theme.dark ? '#A6C5E229' : 'rgba(9, 30, 66, 0.13)'};
`;

export const Timeline = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 12px;
  color: #6b778c;
`;

export const DayPoint = styled.div`
  display: flex;
  width: 100%;
`;

export const WeekPoint = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin-right: 6px;
`;

export const ExpandButton = styled('button')`
  padding: 0px 4px;
  border-radius: 3px;
  border: none;
  line-height: 16px;
  font-weight: bold;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.expand};
  background-color: ${({ theme }) => theme.bgColors.expand};
  &:hover {
    background-color: ${({ theme }) => theme.bgColors.expandHover};
  }
`;

export const AvatarGroup = styled.div`
  display: flex;
  width: ${({ size, count }) => sizes[size][4] + (count - 1) * 20}px;
`;

export const AvatarGroupItem = styled.div`
  display: flex;
  position: relative;
  z-index: ${({ index }) => index + 1};
  right: ${({ index }) => index * 15}px;
`;

export const CounterBadge = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  line-height: 24px;
  // color: var(--ds-text);
  color: ${({ theme }) => theme.colors.primary};
  // border: 1px solid var(--ds-border);
  border: 1px solid ${({ theme }) => theme.colors.primary};
  text-align: center;
  line-height: 24px;
  border-radius: 50%;
  margin-left: 4px;
  margin-top: 4px;
  cursor: pointer;
`;

export const ExpandedWorklogGroupWrapper = styled.div`
  padding-top: 5px;
`;

export const ExpandedWorklogGroup = styled.div`
  padding-left: ${({ isMobile }) => (isMobile ? '5px' : '')};
  border-left: ${({ isMobile }) => (isMobile ? '3px solid #ccc' : '')};
`;
